// extracted by mini-css-extract-plugin
export default {"edit":"bOesOHfAM3kHlq3u0PO8","delete":"InfgOq5GjgSMdu7bsXAv","viewManageTitle":"AYNMXBPINqgDY8MkmL2G","action":"FIbbt6olbYhlPUaZVwXt"};